import { Action, createReducer, on } from '@ngrx/store';
import { IProductSolutionForProductRequest } from '../models/product-solutions-for-product.model';
import * as actions from '../actions';

export const productSolutionsForProductFeatureKey = 'productSolutionsForProduct';

export interface ProductSolutionsForProductState {
  loadProductSolutionsForProductRequest: IProductSolutionForProductRequest;
  loadProductSolutionsForProductResponse: string;
  loadProductSolutionsForProductFailure: Error | any;
}

export const initialState: ProductSolutionsForProductState = {
  loadProductSolutionsForProductRequest: undefined,
  loadProductSolutionsForProductResponse: undefined,
  loadProductSolutionsForProductFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadProductSolutionsForProducts, (state, action) => ({
    ...state,
    loadProductSolutionsForProductRequest: action.request
  })),
  on(actions.loadProductSolutionsForProductsSuccess, (state, action) => ({
    ...state,
    loadProductSolutionsForProductResponse: action.response
  })),
  on(actions.loadProductSolutionsForProductsFailure, (state, action) => ({
    ...state,
    loadProductSolutionsForProductFailure: action.error
  }))
);

export const getProductSolutionsForProducts = (state: ProductSolutionsForProductState) => state.loadProductSolutionsForProductResponse;
